import React from "react";
import {
    useModalForm, Modal, Space, Form,
    Button,
    Switch,
    Typography,
    notification,
} from "@pankod/refine-antd";
import { MailOutlined } from '@ant-design/icons';
import { IUser } from "../../../../interfaces/company";

const { Text } = Typography;

interface SendPasscodeResetEmailModelProps {
    userItem: IUser;
}

export const SendPasscodeResetEmailModel: React.FC<SendPasscodeResetEmailModelProps> = ({
    userItem,
}) => {
    const uacmId = userItem.uacmId;

    const {
        modalProps: sendEmailModal,
        formProps: sendEmailForm,
        show: sendEmailShow,
        close: sendEmailClose,
    } = useModalForm<any>({
        dataProviderName: "grapghQl",
        resource: "sendInternalPortalPasscodeResetEmailForNonOnboardedCompanies",
        action: "create",
        metaData: {
            uacmId: uacmId,
        },
        redirect: false,
        onMutationSuccess() {
            notification.success({
                message: "Success",
                description: "Passcode reset email sent successfully.",
            });
            sendEmailClose();
        },
        onMutationError(error: any) {
            notification.error({
                message: "Error",
                description: error?.message || "Failed to send passcode reset email.",
            });
        },
    });

    sendEmailModal.title = "Send Passcode Reset Email";
    sendEmailModal.centered = true;
    sendEmailModal.width = 500;
    sendEmailModal.okText = "Send Email";
    sendEmailModal.onCancel = () => {
        sendEmailForm.form?.resetFields();
        sendEmailClose();
    };

    return (
        <Space>
            <Button
                onClick={() => sendEmailShow()}
                icon={<MailOutlined />}
            >
                Send Passcode Reset Email
            </Button>

            <Modal {...sendEmailModal}>
                <Text>
                    Send a passcode reset email to <Text strong>{userItem.fullName || userItem.displayName}</Text>?
                </Text>
                <Form {...sendEmailForm} layout="vertical" style={{ marginTop: 16 }}>
                    <Form.Item
                        label="Skip Company Status Check"
                        name="skipCompanyStatusCheck"
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <Switch />
                    </Form.Item>
                    <Text type="secondary">
                        Enable this to skip company onboarding status validation
                    </Text>
                </Form>
            </Modal>
        </Space>
    );
};
